<app-dialog-base
  [titleTranslationKey]="!isEditMode ? 'update-user-role-dialog.add-user-title' : 'update-user-role-dialog.update-user-title'"
>
  <ng-container content>
    <app-form-toggle-filter-users-by-customer-space [isByCustomerSpace]="filterUsersByCustomerSpace()"
      (filterChanged)="filterUsersByCustomerSpace.set($event)" class="mb-20" />

    <form class="update-user-form mt-40" [formGroup]="updateUserForm">
      <div class="form-row">
        <mat-form-field color="accent" class="name-field">
          <mat-label>{{ 'update-user-role-dialog.name' | translate }}</mat-label>
          <input matInput formControlName="user" [matAutocomplete]="autocompleteUsers" required [name]="randomName1" />
          <mat-autocomplete
            #autocompleteUsers="matAutocomplete"
            [displayWith]="getUserDisplayName"
            (optionSelected)="setSelectedUser($event.option.value)"
            autoActiveFirstOption
          >
            <mat-option *ngFor="let user of filteredUsers$ | async" [value]="user">
              {{ getUserDisplayName(user) }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="updateUserForm.get('user')!.hasError('required')">
            {{ 'update-user-role-dialog.name-required' | translate }}
          </mat-error>
        </mat-form-field>
        <app-button-edit *ngIf="userId !== null" class="edit-icon" (click)="goToUserProfile()" />
        <span *ngIf="userId === null" class="edit-spacer"></span>

        <mat-form-field color="accent" class="role-field">
          <mat-label>{{ 'update-user-role-dialog.role' | translate }}</mat-label>
          <mat-select formControlName="roleId" required>
            <mat-option *ngFor="let role of sortedAccessibleRoles" [value]="role.id">
              {{ getTranslatedRoleName(role.name) }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="updateUserForm.get('roleId')!.hasError('required')">
            {{ 'update-user-role-dialog.role-required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-flat-button [routerLink]="[]" (click)="closeDialog()" mat-button>{{ 'shared.cancel' | translate | uppercase }}</button>
    <button mat-flat-button color="primary" [disabled]="!updateUserForm.valid" (click)="saveDialog()" mat-button>
      {{ 'shared.save' | translate | uppercase }}
    </button>
  </ng-container>
</app-dialog-base>
